import { render, staticRenderFns } from "./ElFieldCardDetails.vue?vue&type=template&id=89c600de"
import script from "./ElFieldCardDetails.vue?vue&type=script&lang=js"
export * from "./ElFieldCardDetails.vue?vue&type=script&lang=js"
import style0 from "./ElFieldCardDetails.vue?vue&type=style&index=0&id=89c600de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports